import * as React from "react";
import {CATEGORY_LIST} from "../data/vehicles";

export interface IFilterContext {name: string, icon: string, id: string, fullName: string, iconP: string}

export const FilterContext = React.createContext({
    filterData: CATEGORY_LIST.all as IFilterContext, handleFilterData: (data: IFilterContext) => {}
});